import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const LoginRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const { adminJsession } = useSelector(
    (state) => ({
      adminJsession: state.auth.adminJsession,
    }),
    shallowEqual
  );
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout>
          {!adminJsession ? (
            <Component {...matchProps} />
          ) : (
            <Redirect to="/products" />
          )}
        </Layout>
      )}
    />
  );
};
export default LoginRoute;
